import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronGrabberHorizontal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconChevronGrabberHorizontal"><Path d="M8.99981 16L5.88369 12.8839C5.39554 12.3957 5.39554 11.6043 5.8837 11.1161L8.99981 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M15 8L18.1161 11.1161C18.6043 11.6043 18.6043 12.3957 18.1161 12.8839L15 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconChevronGrabberHorizontal;
